import * as tslib_1 from "tslib";
import createFavoritePersonasRootFolder from '../createFavoritePersonasRootFolder';
import retrieveRootFavoritePersonasFolder from '../retrieveRootFavoritePersonasFolder';
import { logUsage } from 'owa-analytics-actions';
import { PROPERTY_TAG_HIDDEN } from '../createSearchFolderForPersona';
// Retrieves the folderId of 'FavoritePersonas', creates the folder if it doesn't exist
// In case the folder was created between retrieveFavoritePersonasFolder() and createFavoritePersonaFolder()
// we return the created folder
export default function getFavoritePersonasRootFolderId() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritePersonaFolder, reason_1, favoritePersonaFolder;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    return [4 /*yield*/, retrieveRootFavoritePersonasFolder()];
                case 1:
                    favoritePersonaFolder = _a.sent();
                    if (favoritePersonaFolder) {
                        logIsHiddenProperty(favoritePersonaFolder);
                        return [2 /*return*/, favoritePersonaFolder.FolderId.Id];
                    }
                    return [4 /*yield*/, createFavoritePersonasRootFolder()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    reason_1 = _a.sent();
                    if (!(reason_1 === 'ErrorFolderExists')) return [3 /*break*/, 5];
                    return [4 /*yield*/, retrieveRootFavoritePersonasFolder()];
                case 4:
                    favoritePersonaFolder = _a.sent();
                    logIsHiddenProperty(favoritePersonaFolder);
                    return [2 /*return*/, favoritePersonaFolder.FolderId.Id];
                case 5: throw reason_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function logIsHiddenProperty(favoritePersonaFolder) {
    if (!(favoritePersonaFolder && favoritePersonaFolder.ExtendedProperty)) {
        return;
    }
    var isHiddenProperty = favoritePersonaFolder.ExtendedProperty.filter(function (prop) {
        return prop.ExtendedFieldURI &&
            prop.ExtendedFieldURI.PropertyTag &&
            prop.ExtendedFieldURI.PropertyTag.toLocaleLowerCase() === PROPERTY_TAG_HIDDEN;
    });
    var isHidden = isHiddenProperty && isHiddenProperty.length === 1
        ? isHiddenProperty[0].Value
        : 'Property not found';
    logUsage('RootFavoritePersonaFolderLoaded', { isFolderHidden: isHidden });
}
//# sourceMappingURL=getFavoritePersonasRootFolderId.js.map